(function() {
    'use strict';

    angular.module('formTracking', []);

}());
